import moment from "moment"
import StatusEnum from "../common/StatusEnum"


export const getTotalNoAcc=async(dynamoDBClient)=>{
  try {
    const params={
      TableName:"Users",
      FilterExpression: 'RoleId = :roleIdValue',
      ExpressionAttributeValues: {
        ':roleIdValue': "3",
      },
      Select:"COUNT"
    }

    const data=await dynamoDBClient.scan(params).promise()
    
    return data.Count
  } catch (error) {
    throw new Error(error)
  }
    
     
}

export const getTotalBaseStation=async(dynamoDBClient)=>{
  try {
    const params={
      TableName:"GatewayUser",
      Select:"COUNT"
    }

    const data=await dynamoDBClient.scan(params).promise()
    return data.Count
  } catch (error) {
    throw new Error(error)
  }
    
}

export const getTotalBeacons=async(dynamoDBClient)=>{
  try {
    const params={
      TableName:"Beacons",
      Select:"COUNT"
    }

    const data=await dynamoDBClient.scan(params).promise()
    return data.Count
  } catch (error) {
    throw new Error(error)
  }
    
}

export const getTotalActiveAccount=async(dynamoDBClient)=>{
  try {
    const params={
      TableName:"Users",
      Select:"COUNT",
      FilterExpression:"IsEnabled = :enabled and RoleId = :roleIdValue",
      ExpressionAttributeValues:{
        ":enabled":true,
        ':roleIdValue': "3",
      }
    }

    const data=await dynamoDBClient.scan(params).promise()
    return data.Count
  } catch (error) {
    throw new Error(error)
  }
    
}






export const getBaseStationCounts=async(dynamoDBClient)=>{
  try {
    const params1={
      TableName:"GatewayData",
      ProjectionExpression:"DateUpdated,GatewayMAC, Email"
    }

    const params2={
      TableName:"BeaconData",
      ProjectionExpression:"BeaconMAC, GatewayMac"
    }

    const params3={
      TableName:"GatewayUser",
      ProjectionExpression:"GatewayMAC, Email"
    }


    const baseStationData=[]
    const snoozeData=[]
    const data2=await dynamoDBClient.scan(params1).promise()
    const data3=await dynamoDBClient.scan(params3).promise()
    const arr=data2.Items
    const gatewayUser=data3.Items
    
    
    if(arr.length>0 && gatewayUser.length>0){
      const snoozeParams={
        TableName:"SnoozeSettings",
        ProjectionExpression:"SnoozeTimeStampEnd , SnoozeTimeStampStart, BeaconMAC"
      }
      const result= await dynamoDBClient.scan(snoozeParams).promise();
      const snoozeResult=result.Items
      if(snoozeResult.length>0){
        const data3=await dynamoDBClient.scan(params2).promise()
        
        const arr2=data3.Items
        const unique=new Set(snoozeResult.map(obj=>obj.BeaconMAC))
        
        for(const obj of arr2){
          if(unique.has(obj.BeaconMAC)){
            snoozeData.push(obj)
          }
        }
      }
      
      await Promise.all(arr.map(async(element) => {
        if(snoozeResult.length>0){
          const data3=snoozeData.filter(snoozeItem=>snoozeItem.GatewayMac===element.GatewayMAC)
          
          
          if(data3.length>0){
            const snoozeGateway=data3[0]
           
            const data4=snoozeResult.filter(item=>item.BeaconMAC===snoozeGateway.BeaconMAC)
           
            if(data4.length>0){
              const snooze=data4[0]
              const now=moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSSSSS')
              const isBetween=moment(now).isBetween(snooze.SnoozeTimeStampStart,snooze.SnoozeTimeStampEnd)
              
              if(isBetween){
                baseStationData.push({
                  DateUpdated:element.DateUpdated,
                  Status:StatusEnum.snoozed,
                  GatewayMAC:element.GatewayMAC
                })
              }else{
                baseStationData.push({
                  DateUpdated:element.DateUpdated,
                  Status:StatusEnum.online,
                  GatewayMAC:element.GatewayMAC
                })
              }
            }
            
          }else{
            const hasGateway=gatewayUser.some(gateway=>gateway.GatewayMAC === element.GatewayMAC && gateway.Email === element.Email)
            if(hasGateway){

              baseStationData.push({
                DateUpdated:element.DateUpdated,
                Status:StatusEnum.online,
                GatewayMAC:element.GatewayMAC
              })
            }
          }
          

        }else{
          const hasGateway=gatewayUser.some(gateway=>gateway.GatewayMAC === element.GatewayMAC && gateway.Email === element.Email)
          if(hasGateway){
            baseStationData.push({
              DateUpdated:element.DateUpdated,
              Status:StatusEnum.online,
              GatewayMAC:element.GatewayMAC
            })
          }
        }
      }))




    }
    
    const commonGateway=baseStationData.filter(obj1=>gatewayUser.some(obj2=>obj1.GatewayMAC===obj2.GatewayMAC))
    
    return commonGateway
  } catch (error) {
    throw new Error(error)
  }
  

}

export const getBeaconCounts=async(dynamoDBClient)=>{
  try {
    const params1={
      TableName:"BeaconData",
      ProjectionExpression:"DateUpdated, BeaconMAC, Email"
    }
    const params2={
      TableName:"Beacons",
      ProjectionExpression:"BeaconMAC, Email"
    }
    const beaconData=[];
    const data2=await dynamoDBClient.scan(params1).promise()
    const data3=await dynamoDBClient.scan(params2).promise()
    
    const arr=data2.Items
    const beacons=data3.Items
    if(arr.length>0 && beacons.length>0){
      const snoozeParams={
        TableName:"SnoozeSettings",
        ProjectionExpression:"SnoozeTimeStampEnd , SnoozeTimeStampStart, BeaconMAC, Email"
      }
      const result= await dynamoDBClient.scan(snoozeParams).promise();
      const snoozeResult=result.Items
      await Promise.all(arr.map(async(element) => {
        if(snoozeResult.length>0){
          const data3=snoozeResult.filter(snoozeItem=>snoozeItem.BeaconMAC===element.BeaconMAC && snoozeItem.Email === element.Email)
          if(data3.length>0){
            const snooze=data3[0]
            const now=moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSSSSS')
            const isBetween=moment(now).isBetween(snooze.SnoozeTimeStampStart,snooze.SnoozeTimeStampEnd)
            if(isBetween){
              beaconData.push({
                DateUpdated:element.DateUpdated,
                BeaconStatus:StatusEnum.snoozed,
                BeaconMAC: element.BeaconMAC
              })
            }else{
              beaconData.push({
                DateUpdated:element.DateUpdated,
                BeaconStatus:StatusEnum.online,
                BeaconMAC: element.BeaconMAC
              })
            }
          }else{
            const hasbeacon=beacons.some(beacon=>beacon.BeaconMAC === element.BeaconMAC && beacon.Email === element.Email)
            if(hasbeacon){

              beaconData.push({
                DateUpdated:element.DateUpdated,
                BeaconStatus:StatusEnum.online,
                BeaconMAC: element.BeaconMAC
              })
            }
          }
          

        }else{
          const hasbeacon=beacons.some(beacon=>beacon.BeaconMAC === element.BeaconMAC && beacon.Email === element.Email)
          if(hasbeacon){

            beaconData.push({
              DateUpdated:element.DateUpdated,
              BeaconStatus:StatusEnum.online,
              BeaconMAC: element.BeaconMAC
              })
            }
          }
        }
      ))
           
    }

    const commonBeacons=beaconData.filter(obj1=>beacons.some(obj2=>obj1.BeaconMAC===obj2.BeaconMAC))
    return commonBeacons
  } catch (error) {
    throw new Error(error)
  }
  

}



